import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownMenu from "./DropdownMenu";

const MobileNotification = ({ showNotification, setShowNotification }) => {
  const closeModalHandler = () => setShowNotification(false);
  return (
    <div className="">
      <Modal
        dialogClassName={"MobileNotification"}
        show={showNotification}
        onHide={closeModalHandler}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="message-header">
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal-title message-title"
          ></Modal.Title>
        </Modal.Header>
        <Modal.Body className="mobile-content">
          <span className="notification_dropdown mobile_dropdown">
            <Dropdown>
              <Dropdown.Toggle variant="" id="dropdown-basic">
                <span className="show_notification">Show Notification</span>
              </Dropdown.Toggle>

              <DropdownMenu {...{ showNotification, setShowNotification }} />
            </Dropdown>
          </span>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={props.onHide}>Close</Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MobileNotification;
